import React from "react";
import HeroSlider from "../components/HeroSlider";
import BrandsCarousel from "../components/BrandsCarousel";
import PageHero from "../components/PageHero";
import AnimatedButton from "../components/AnimatedButton";
import { Link } from "react-router-dom";



export const Home = () => (
  <>
    {/* <PageHero
      title="Welcome to Vinayaka Paints"
      subtitle="Vibrant palettes for every surface"
      image={process.env.PUBLIC_URL + "/images/home-hero.svg"}
    /> */}
    <HeroSlider />
    <BrandsCarousel />
    <section className="section about-teaser">
      <h2>About Sri Vinayaka Enterprises</h2>
      <p>With a legacy spanning more than 35 years, Sri Vinayaka Enterprises has established itself as a premier name in the paint and coatings industry, built on a foundation of deep technical expertise and unwavering customer trust. Over three and a half decades, we have evolved from a local paint supplier into a major industry player, consistently providing high-quality solutions for residential, commercial, and industrial projects. Our long-standing history is a testament to our commitment to excellence, ensuring that every customer benefits from the decades of insight we bring to every surface and coating challenge.</p>
      <div className="read-more-row"><Link className="read-more-btn" to="/about">Read More</Link></div>
    </section>
  </>
);

export const About = () => (
  <>
    <PageHero
      title="About Vinayaka Enterprises"
      subtitle="Premium quality, eco-friendly paints for inspired spaces"
      image={process.env.PUBLIC_URL + "/images/about-hero.svg"}
    />
    <section className="section">
      <h2>About Us</h2>
      <p>With a legacy spanning more than 35 years, Sri Vinayaka Enterprises has established itself as a premier name in the paint and coatings industry, built on a foundation of deep technical expertise and unwavering customer trust. Over three and a half decades, we have evolved from a local paint supplier into a major industry player, consistently providing high-quality solutions for residential, commercial, and industrial projects. Our long-standing history is a testament to our commitment to excellence, ensuring that every customer benefits from the decades of insight we bring to every surface and coating challenge.
<br/>
<br/>
Our strength lies in our robust supply capabilities and our strategic associations with India’s most iconic paint brands. As a prominent Distributor for Berger Paints and a leading Wholesaler for Asian Paints and Sheenlac, we offer an unparalleled range of products that cater to every aesthetic and functional requirement. By maintaining these direct relationships, we guarantee our clients 100% genuine products and the latest innovations in decorative and protective finishes. Our role as a wholesaler and distributor allows us to combine large-scale availability with competitive pricing, making us the preferred partner for contractors, builders, and homeowners alike.
<br/>
<br/>
At Sri Vinayaka Enterprises, we believe that our 35-year journey is just the beginning. While we take immense pride in our heritage and the reputation we have built for honesty and integrity, we remain focused on the future by embracing eco-friendly technologies and modern coating solutions. We don't just supply paint; we provide the expert guidance necessary to transform spaces. Whether it is a luxury interior finish or a durable industrial coating, we continue to serve our community with the same passion and dedication that has defined us for over three and a half decades.</p>
    </section>
    <section className="section achievements">
      <h2>Achievements</h2>
      <div className="achievements-gallery" role="list">
        <div className="achievement-tile" role="listitem">
          <img src={process.env.PUBLIC_URL + "/images/achievements/a1.png"} alt="Best Eco-Friendly Paint 2023" />
          <div className="info">
            <h3>Beger Gold Card Dealer 2023-24</h3>
            
          </div>
        </div>
        <div className="achievement-tile" role="listitem">
          <img src={process.env.PUBLIC_URL + "/images/achievements/a2.png"} alt="Top Coverage Award" />
          <div className="info">
            <h3>ESQUIRE CLUB 2023-24</h3>
          </div>
        </div>
        {/* <div className="achievement-tile" role="listitem">
          <img src={process.env.PUBLIC_URL + "/images/achievements/a3.png"} alt="Durability Excellence" />
          <div className="info">
            <h3>Durability Excellence</h3>
            <p>WeatherGuard line wins for long-term outdoor resilience.</p>
          </div>
        </div> */}
        <div className="achievement-tile" role="listitem">
          <img src={process.env.PUBLIC_URL + "/images/achievements/a4.png"} alt="Customer Choice" />
          <div className="info">
            <h3>Beger Gold Card Dealer 2022-23</h3>
          </div>
        </div>
      </div>
    </section>
  </>
);

const sampleProducts = [
  { name: "Interior Emulsion", price: "$29.99", sale: "10% off", desc: "Smooth matte finish for interiors.", color: "#ff6b6b" },
  { name: "Exterior WeatherGuard", price: "$39.99", sale: "15% off", desc: "Durable against harsh climate.", color: "#feca57" },
  { name: "Luxury Silk", price: "$49.99", sale: "20% off", desc: "Silky sheen for premium look.", color: "#1dd1a1" },
  { name: "Primer Pro", price: "$19.99", sale: "5% off", desc: "Strong adhesion base coat.", color: "#54a0ff" }
];

export const Products = () => (
  <>
    <PageHero
      title="Our Products"
      subtitle="From interior mattes to weather-resistant exteriors—find the perfect finish"
      image={process.env.PUBLIC_URL + "/images/products-hero.svg"}
    />
    <section className="section">
      <h2>Products</h2>
      <div className="product-grid">
        {sampleProducts.map((p, idx) => (
          <div key={idx} className="product-card" style={{ background: `linear-gradient(135deg, ${p.color} 0%, #ffffff 100%)` }}>
            <div className="product-info">
              <h3>{p.name}</h3>
              <p className="desc">{p.desc}</p>
              <div className="price-row">
                <span className="price">{p.price}</span>
                <span className="sale">{p.sale}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  </>
);

export const Contact = () => (
  <>
    <PageHero
      title="Contact Us"
      subtitle="We'd love to hear from you"
      image={process.env.PUBLIC_URL + "/images/home-hero.svg"}
    />
    <section className="section">
      <h2>Contact Us</h2>
      <div className="contact-grid">
        <div>
          <h3>Social Media</h3>
          <ul className="list">
            {/* <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a></li> */}
            <li><a className="contact-link" href="https://www.instagram.com/srivinayakaenterprises18?igsh=MW1rd3I3dnpnbjRiaA==" target="_blank" rel="noopener noreferrer">Instagram</a></li>
            {/* <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer">X/Twitter</a></li>
            <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a></li> */}
          </ul>
        </div>
        <div>
          <h3>Locations</h3>
          <ul className="list">
          <li><a className="contact-link location" href="https://maps.app.goo.gl/AQugzM2YhGT8s6rG6?g_st=iw">Madurai, Teppakulam</a></li>
            <li><a className="contact-link location" href="https://maps.app.goo.gl/eRYAEnu9kMe3f3dh7?g_st=iw">Sivaganga, Thirupuvanam</a></li>
            <li><a className="contact-link location" href="https://maps.app.goo.gl/JCHM3Bwvcdvdehtz7?g_st=iw">Sivaganga, Karaikudi</a></li>
          </ul>
        </div>
        <div>
          <h3>WhatsApp</h3>
          <p>Reach us instantly via WhatsApp.</p>
          <AnimatedButton
            className="whatsapp"
            href="https://wa.me/919677657643?text=Hello%20Paints"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact on WhatsApp
          </AnimatedButton>

        </div>
      </div>
    </section>
  </>
);

export const Footer = () => (
  <footer className="footer">
    <div className="footer-inner">
      <div className="abstract">
        <h4>ColorSplash Paints</h4>
        <p>Abstract: We deliver colorful, durable paint solutions for every surface. Replace this text with your company abstract.</p>
      </div>
      <div className="rights">
        <p>© {new Date().getFullYear()} ColorSplash Paints. All rights reserved.</p>
      </div>
    </div>
  </footer>
);